import React from 'react';

interface ExamShieldProps {
  locked?: boolean;
  assessmentActive: boolean;
  fullscreenOk: boolean;
  blurFlash: boolean;
  watermarkLabel: string;
  onEnterFullscreen: () => void;
  children: React.ReactNode;
}

export function ExamShield({
  locked,
  assessmentActive,
  fullscreenOk,
  blurFlash,
  watermarkLabel,
  onEnterFullscreen,
  children,
}: ExamShieldProps) {
  if (locked) {
    return (
      <div className="exam-shield exam-shield--locked">
        <div className="exam-shield__panel">
          <span className="exam-shield__icon" aria-hidden>
            🛡
          </span>
          <h2 className="exam-shield__title">Evaluación suspendida</h2>
          <p className="exam-shield__text">
            Saliste de la pantalla o perdiste el foco. Habla con tu profesor para reactivar tu intento.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`exam-shield${blurFlash ? ' exam-shield--blur-flash' : ''}`}>
      {assessmentActive && (
        <>
          <div className="exam-shield__watermark" aria-hidden>
            {Array.from({ length: 12 }).map((_, i) => (
              <span key={i}>{watermarkLabel}</span>
            ))}
          </div>
          {!fullscreenOk && (
            <div className="exam-shield__gate">
              <p className="exam-shield__gate-title">Modo evaluación blindada</p>
              <p className="exam-shield__gate-hint">
                Entra en pantalla completa para comenzar. No cambies de pestaña durante la prueba.
              </p>
              <button type="button" className="sala-btn-hero text-xs" onClick={onEnterFullscreen}>
                Pantalla completa
              </button>
            </div>
          )}
        </>
      )}
      <div className={assessmentActive && !fullscreenOk ? 'exam-shield__content--dimmed' : undefined}>
        {children}
      </div>
    </div>
  );
}
